var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuesSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.777778 0.87207H11.6667L13.7721 2.97751C13.918 3.12334 14 3.32114 14 3.5274V14.0943C14 14.3006 13.9181 14.4984 13.7722 14.6443C13.6263 14.7901 13.4285 14.8721 13.2222 14.8721H0.777778C0.571498 14.8721 0.373667 14.7901 0.227806 14.6443C0.0819442 14.4984 0 14.3006 0 14.0943V1.64985C0 1.44357 0.0819442 1.24574 0.227806 1.09988C0.373667 0.954014 0.571498 0.87207 0.777778 0.87207ZM3.11111 1.64985V5.53874H10.1111V1.64985H3.11111ZM2.33333 7.87207V13.3165H11.6667V7.87207H2.33333ZM7.77778 2.42763H9.33333V4.76096H7.77778V2.42763Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuesSaved);
export default __webpack_public_path__ + "static/media/icon-ques-saved.9c00c86a700e6cab96ace75f9dfe6488.svg";
export { ForwardRef as ReactComponent };